module.exports = __webpack_public_path__ + "img/arrows.eed5f238.png";